import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=06a5369c&scoped=true&"
import script from "./UsersList.vue?vue&type=script&setup=true&lang=js&"
export * from "./UsersList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a5369c",
  null
  
)

export default component.exports